import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Award, Shield, CheckCircle } from "lucide-react";

const About = () => {
  return (
    <section id="about" className="py-8 px-4">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-6">
          <h2 className="text-2xl md:text-3xl font-bold text-primary-dark mb-2">About NearLab Services</h2>
          <p className="text-sm md:text-base text-gray-700 max-w-2xl mx-auto">
            AABB-certified testing brought directly to you — accurate, reliable, and private.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mb-6">
          {/* AABB Badge */}
          <Card className="border-2 border-primary-dark bg-gradient-to-r from-primary-light/50 to-blue-light/30">
            <CardContent className="pt-4 pb-4 text-center">
              <div className="p-2 bg-primary-dark rounded-full w-fit mx-auto mb-2">
                <Award className="text-white" size={20} />
              </div>
              <Badge variant="outline" className="bg-white text-primary-dark font-semibold px-2 py-0.5 text-xs mb-2">
                AABB CERTIFIED
              </Badge>
              <p className="text-xs text-gray-700">
                Gold-standard accredited labs ensuring accuracy and legal admissibility.
              </p>
            </CardContent>
          </Card>

          {/* How We Work */}
          <Card className="border-t-4 border-primary-dark">
            <CardContent className="pt-4 pb-4">
              <h3 className="text-base font-bold text-primary-dark mb-2">How We Work</h3>
              <p className="text-xs text-gray-700">
                Our certified technicians come to your home, office, or any location. Proper chain of custody for court-admissible results.
              </p>
            </CardContent>
          </Card>

          {/* Quality */}
          <Card className="border-t-4 border-primary-dark">
            <CardContent className="pt-4 pb-4">
              <h3 className="text-base font-bold text-primary-dark flex items-center gap-1 mb-2">
                <Shield size={16} />
                Quality & Compliance
              </h3>
              <ul className="space-y-1">
                {["AABB-accredited labs", "Certified technicians", "Chain of custody", "99.9%+ accuracy", "Court-admissible", "ISO-compliant"].map((item) => (
                  <li key={item} className="flex items-center text-xs">
                    <CheckCircle className="w-3 h-3 mr-1.5 text-primary-dark shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default About;
